import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSmileyEmojiSecondary from './svgs/SmileyEmojiSecondary.js';
import SvgSmileyEmoji from './svgs/SmileyEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var smileyEmoji = (props => useIcon(SvgSmileyEmoji, SvgSmileyEmojiSecondary, props));

export { smileyEmoji as default };
